import { datadogLogs } from "@datadog/browser-logs";
import { getVar } from "config";

const isDev = getVar("REACT_APP_ENV") === "dev";

datadogLogs.logger.setHandler(isDev ? ["console", "http"] : "http");
export default datadogLogs.logger;
